module.exports = __webpack_public_path__ + "img/w12-b3.feaaa946.jpg";